// Extracts the number from the end of a string (e.g., 'Main Street 123' -> '123')
export function extractNumber(str) {
  const match = str?.match(/\d+/);
  return match ? match[0] : '';
}

// Extracts the street name from the start of a string (e.g., 'Main Street 123' -> 'Main Street')
export function extractStreet(str) {
  const match = str?.match(/^\D+/);
  return match ? match[0].trim() : '';
}
